import React from 'react';
import logo from '../assets/logo.png';

function Logo({ height }) {
	return (
		<div className='min-w-fit'>
			<div className='flex items-center'>
				<img src={logo} alt='logo' className={`${height}`} />
			</div>
		</div>
	);
}

export default Logo;
